export { default as animate } from './animate.js';
export { default as copyToClipboard } from './copyToClipboard.js';
export { default as getDarkerColor } from './getDarkerColor.js';
export { default as getIndex } from './getIndex.js';
